export default {
    EXCEL_MAX_ROWS: 1048576 // max number of rows in Excel worksheet. See: https://goo.gl/e5imsp
};
